<template>
  <div class="wy-analytics-contact-reasons-page-header">
    <table border="0" class="list-header" cellspacing="0" cellpadding="0">
      <tr style="display: flex; width: calc(100% - 2px); flex-direction: column;" valign="absmiddle">
        <td style="display: flex; justify-content: space-between;" class="col1">
          <div style="display:flex; height:35px;">
            <div>
              <div class="title">{{ $t(currentPageInfo.title) }}</div>
            </div>
            <div class="question-mark">
              <wy-page-tooltip />
            </div>
          </div>
          <el-button v-if="enableExport" class="export-btn" round @click="handleExport">
            <div class="export-icon"></div>
            <span class="export-text">Export</span> 
          </el-button>
        </td>

        <!-- <div class="table-header"><span style="padding-left:22px">Conversation Topics</span></div> -->
        <td class="col3 table-header-middle">
          <div style="display: flex;align-items: center;">
            <wy-table-search :controller="controller" v-if="!hideSearchColumnUI" />

            <el-dropdown v-if="false" class="action-dropdown" trigger="click">
              <span style="display:flex; align-items: center;" class="el-dropdown-link">
                <img style="margin-right: 5px;" src="../../../assets/icons/icon_action_dropdown.svg" alt="">
                Actions
              </span>
              <el-dropdown-menu class="actionDropdown" slot="dropdown">
                <el-dropdown-item class="contact-reason-compare-metrics" @click.native="handleCompareMetrics"
                  :disabled="!enableCompareMetrics">Compare Conversation Topics</el-dropdown-item>
                <el-dropdown-item class="contact-reason-merge-topic" @click.native="handleMergeTopics"
                  :disabled="!enableMergeTopics">Group Conversation Topics</el-dropdown-item>
                <el-dropdown-item v-if="controller.handleBlackList" class="contact-reason-black-list" @click.native="handleBlackList"
                  :v-if="enableBlackList" :disabled="!enableBlackList">Add to blacklist</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div>
            <wy-table-column v-if="!hideSearchColumnUI" ref="columnSelectionDropdown" :controller="controller" />
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ObjectsToCsv from 'objects-to-csv';
import WyTableColumn from '../../widgets/wy-table-column';
import WyTableSearch from '../../widgets/wy-table-search';
import wyPageTooltip from '../../widgets/wy-page-tooltip.vue'

export default {
  name: 'wy-interactions-phrase-categories-header',
  props: ['controller'],
  data() {
    return {
      selectAll: false
    }
  },
  components: {
    'wy-table-column': WyTableColumn,
    'wy-table-search': WyTableSearch,
    'wy-page-tooltip': wyPageTooltip
  },

  computed: {
    ...mapGetters(['dataModel', 'tableModel', 'isRoleAllow', 'currentPageInfo', 'authUser']),

    enableCompareMetrics() {
      return (this.isRoleAllow([4210]) && this.controller.tableModel.selectedRows && this.controller.tableModel.selectedRows.length > 0);
    },
    enableBlackList() {
      return (this.isRoleAllow([4201, 900011]) && this.controller.tableModel.selectedRows && this.controller.tableModel.selectedRows.length > 0);
    },
    enableMergeTopics() {
      return (this.isRoleAllow([4201, 900011]) && this.controller.tableModel.selectedRows && this.controller.tableModel.selectedRows.length > 1);
    },
    enableExport() {
      return (this.controller.tableModel.selectedRows && this.controller.tableModel.selectedRows.length > 0);
    },
    hideSearchColumnUI() {
      let available = true;
      if (this.tableModel && this.tableModel.results && this.tableModel.results.length == 0) {
        available = false;
      }
      return !available;
    }
  },

  methods: {
    handleCompareMetrics() {
      this.controller.handleCompareMetrics();
    },

    handleMergeTopics() {
      this.controller.handleMergeTopics();
    },

    handleBlackList() {
      this.controller.handleBlackList();
    },

    async handleExport() {
      // get the name of the row

      const selectedColumns = this.controller.dataModel.columns.slice(2).filter(column => column.selected);
      const selectedRows = this.controller.tableModel.selectedRows;

      let exportResult = []
      let exportRow = {}
      let sentimentValue;
      let value = "N/A"

      selectedRows.map(row => {
        exportRow["Topic Name"] = row["topicDisplayName"]
        selectedColumns.map((column, index) => {
          const columnName = `${column.group} ${column.label}`;
          const columnValue = row[column.name];

          if (columnName.includes("%")) {
            value = `${Number(columnValue).toLocaleString()}%`
          } else if (typeof columnName == "number") {
            value = Number(columnValue).toLocaleString()
          } else { // string type
            value = columnValue
          }

          // Sentiment % Change ColumnName is the same for all 3 sentiments
          // ColumnName: "% change from last period"
          if (columnName.includes("Sentiment %")) {
            if (selectedColumns[index - 1].label == "Positive") sentimentValue = "Positive";
            if (selectedColumns[index - 1].label == "Neutral") sentimentValue = "Neutral";
            if (selectedColumns[index - 1].label == "Negative") sentimentValue = "Negative";
            if (columnValue == null || columnValue == -1) {
              return exportRow[`${columnName}-${sentimentValue}`] = "N/A";
            }
            return exportRow[`${columnName}-${sentimentValue}`] = value;
          }

          if (columnValue == null || columnValue == -1) {
            return exportRow[columnName] = "N/A";
          }
          else {
            this.dataModel.columns.forEach(el => {
              if (el.name == column.name && el.selected == true) {
                if (typeof value == 'string') {
                  exportRow[columnName] = value.replace(/(<([^>]+)>)/ig, '');
                }
                else {
                  exportRow[columnName] = value;
                }
              }
            })
          }

          delete exportRow["Volume Trend"]
        });
        exportResult.push(exportRow);
        exportRow = {};
      });

      const csv = new ObjectsToCsv(exportResult);
      const csvContent = await csv.toString();
      //let csvContent = csvHeaders + WyUtils.convertObjToCSV(exportItems);
      let exportedFilenmae = `${this.authUser.company.name.replace(/ /g, "_")}_Phrase_Categories_${this.dataModel.dateStart}_to_${this.dataModel.dateEnd}.csv`;
      let blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      let downloadLink = document.createElement("a");
      if (downloadLink.download !== undefined) {
        let url = URL.createObjectURL(blob);
        downloadLink.setAttribute("href", url);
        downloadLink.setAttribute("download", exportedFilenmae);
        downloadLink.style.visibility = 'hidden';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    }
  },

  mounted() {
    this.$root.$on(`select-all-change-events`, bool => {
      this.selectAll = bool;
    })
  }
}
</script>

<style lang="scss">
.contact-reason-compare-metrics {
  cursor: pointer;
  background-image: url('../../../assets/icons/icon_comparison.svg') !important;
  background-repeat: no-repeat;
  background-position-y: 10px;
  background-position-x: 25px;
  padding-left: 60px;
  display: flex;
  align-items: center;
  height: 45px;
  border: 0px;
  background-color: transparent;
}

.action-dropdown {
  position: absolute;
  left: 346px;
  border: 1px solid #CAD2DA;
  padding: 0px 11px;
  color: #202223;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 29px;
  margin-left: 10px;
}

.actionDropdown {
  width: 320px;
  left: 676px !important;

  .el-dropdown-menu__item.is-disabled {
    opacity: 0.5;
  }
}

.contact-reason-black-list {
  cursor: pointer;
  background-image: url('../../../assets/icons/icon_blacklist.svg') !important;
  background-repeat: no-repeat;
  background-position-y: 10px;
  background-position-x: 25px;
  display: flex;
  align-items: center;
  padding-left: 60px;
  height: 45px;
  border: 0px;
  background-color: transparent;
}

.contact-reason-merge-topic {
  cursor: pointer;
  background-image: url('../../../assets/icons/icon_merged.svg') !important;
  background-repeat: no-repeat;
  background-position-y: 10px;
  background-position-x: 25px;
  display: flex;
  align-items: center;
  padding-left: 60px;
  height: 45px;
  border: 0px;
  background-color: transparent;
}

.wy-analytics-contact-reasons-page-header {
  .wy-page-tooltip .info-icon {
    right: 6px;
    top: -4px;
  }

  td.col3.table-header-middle {
    // border: 1px solid #CAD2DA;
    display: flex;
    justify-content: space-between;
    height: 60px;
    width: calc(100% + 2px);
    padding: 15px 0px 14px 0px;
    background-color: #FFF;
    border-top: unset;
    align-items: center;
  }

  .table-header {
    border: 1px solid #CAD2DA;
    height: 60px;
    background-color: #FFF;
    color: var(--site-font-secondary-color);
    font-weight: 500;
    display: flex;
    font-size: 20px;
    width: calc(100% + 2px);
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    margin-top: 20px;
    align-items: center;
  }

  >table {
    width: 100%;

    .col3 {
      text-align: right;
      display: flex;
      float: right;
    }

    .export-btn {
      box-sizing: border-box;
      border-radius: 5px;
      background: var(--site-button-secondary-btn-background-primary-color);
      color: var(--site-button-secondary-btn-text-primary-color) !important;
      border: 1px solid var(--site-button-secondary-btn-hover-border-primary-color);
      padding: 6px 15px 9px 11px !important;
      width: 90px;
      font-size: 16px !important;
      font-weight: 500 !important;
      height: 35px;
      float: right;
      margin-top: 0px;
    }

    .export-btn:hover {
      border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
      background-color: var(--site-button-secondary-btn-hover-background-primary-color) !important;
      border-radius: 5px;
      color: var(--site-button-secondary-btn-text-primary-color) !important;
    }
    .export-btn:active {
      background-color: var(--site-button-secondary-btn-pressed-background-primary-color) !important;
    }
    .export-btn:focus {
      border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
      border-radius: 5px;
      color: var(--site-button-secondary-btn-text-primary-color) !important;
    }
    .export-icon {
      background: var(--icon_action_export);
      height: 17px;
      width: 13px;
      position: relative;
      top: 2px;
      height: 17px;
      width: 13px;
      display: inline-block;
      background-repeat: no-repeat;
    }
    .export-text {
      position: relative;
      bottom: 1px;
      left: 5px;
    }
  }

  // .list-header {
  //   margin-bottom: 8px;
  // }

  .list-header-group {
    display: inline-flex;
  }

  .small-title {
    color: var(--site-font-secondary-color);
    font-size: 15px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 400;
  }

  .title {    
    color: var(--site-font-secondary-color);
    font-size: 25px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 600;
    width: 257px;
    line-height: 0.7;
  }

  .column-filter {
    height: 34px;
    display: inline-block;
  }

  .question-mark {
    display: inline-block;
    width: 20px;
    padding-top: 3px;
    margin-left: 0px;

    .el-question-mark {
      cursor: pointer;
      // background-image: url('../../../assets/icons/info_hover.svg');
      // background-size: 80%;
      // background-repeat: no-repeat;
      // background-position-y: 0px;
      color: #214586;
      height: 30px;
      border-radius: 1px;
      border: 0px;
      padding: 2px 5px 8px 5px;
      background-color: transparent;
    }

    .el-question-mark:hover {
      color: #214586;
      // background-image: url('../../../assets/icons/info_hover.svg');
      // background-color: unset;
    }

    .el-button:focus,
    .el-button:hover {
      background-color: transparent;
    }
  }

  .el-button {
    padding: 10px 15px 20px 15px;
    margin-left: 0px;
    margin-right: 0px;
  }
}

.div-icons {
  display: inline-block;
  padding-left: 8px;
}

.contact-reason-question-pop-over {
  word-break: keep-all;

  .popper__arrow {
    display: block !important;
  }
}

.el-popover {
  padding: 30px;
  text-align: left;
}
</style>
